import { Flex, SpaceProps, VStack } from '@chakra-ui/react';
import * as React from 'react';
import { SurveyBanner } from '../../survey-banner/views';
import { Navbar } from '../Navbar/Navbar';

type UIProps = {
  containerPadding?: SpaceProps['padding'];
};

export const UI: React.FC<React.PropsWithChildren<UIProps>> = ({ children, containerPadding }) => (
  <Flex height="100%" flexDirection="column" alignItems={'center'} w="100%" bgColor={'white'}>
    <VStack
      w="100%"
      position="sticky"
      top="0px"
      zIndex={10}
      bgColor={'white'}
      borderBottomColor={'gray.100'}
      borderBottomWidth={1}>
      <Navbar />
    </VStack>
    <SurveyBanner />
    <Flex
      w="100%"
      justifyContent={'flex-start'}
      flexDirection="column"
      maxW={'1500px'}
      flex={1}
      paddingY={containerPadding ?? ['20px', '20px', '20px', '50px']}
      paddingX={containerPadding ?? ['20px', '20px', '20px', '30px']}>
      {children}
    </Flex>
  </Flex>
);
